"use strict";
/**
 * Supplier Payments — response contracts
 */
Object.defineProperty(exports, "__esModule", { value: true });
